export const ERRORS_TO_LOG_ONLY_ONCE: Record<string, boolean> = {
    "Failed to fetch": false,
    "Load failed": false,
    "NetworkError when attempting to fetch resource.": false,
};
